import { useState, useEffect, Fragment} from "react";
import Footer from "../UI/Footer/Footer";
import classes from "./BehindTheScenes.module.scss";
import { getCdnPath, updateContentStatus, postEvent, createMarkup} from "../../utils/helpers";
import AgeGate from "../AgeGate/AgeGate";
import Button
 from "../UI/Button/Button";
const BehindTheScenes = (props) => {
    const [imageError, setImageError] = useState(null)
    const [showAgeGate, setShowAgeGate] = useState(null)
    const [videoPlayEventTracked, setVideoPlayEventTracked] = useState(null)
    const [sharable, setSharable] = useState(null);

    const onImageError = () => {}
    const toggleLoading = () => {}
    const handleAgeEntered = () => {}
    const exitFullscreenMode = () => {
        props.onExitFullscreenMode();
    }
    const content = props.content?.content ? props.content?.content : props.content;
    const device = props.device;
    const user = props.user;

    useEffect(() => {
        console.log(content);
        for(const element of content.tags) {                
            if(element.name === 'sharable') {
                setSharable(true);
            }
        }
    }, [])

    return (
        <div
        className={classes.ContentContainer} style={{backgroundColor: "none"}}           
        id={'responsiveContentContainer'}>

        <div>
            <section className={classes.HeroContainer}>
                {imageError ? (
                    <div className={classes.FallbackHero}>
                        <div>Image Loading Error</div>
                    </div>
                ) : (
                    ''
                )}
                <div className={classes.HeroImage}>
                    {!imageError ? (
                        <img
                            src={getCdnPath(content?.hero)}
                            alt={content?.hero}
                            onLoad={() => toggleLoading(false)}
                            onError={onImageError}
                        />
                    ) : (
                        ''
                    )}
                </div>
            </section>
            {showAgeGate ? (
                <Fragment>
                    <div
                        className={classes.ContentItems}
                        style={{
                            width: '312px',
                            height: '320px',
                            borderRadius: '12px',
                            backgroundColor: '#FFFFFF',
                            boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)',
                            margin: '0 auto 15px auto',
                        }}>
                        <AgeGate onAgeEntered={handleAgeEntered} />
                    </div>
                </Fragment>
            ) : (
                <div>
                    {/* <img src={applicationLogo} alt="Application Logo"/> */}
                    <div className={classes.ContentItems} style={{
                            paddingLeft: "15px", 
                            paddingRight: "15px", 
                            paddingTop: "20px", 
                            paddingBottom: "20px", 
                            width: "80%", 
                            marginLeft: "auto", 
                            marginRight: "auto", 
                            backgroundColor: "white", 
                            borderRadius: "20px", 
                            boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)"}}>
                        <div className={classes.Title} style={{
                                color: "black", 
                                fontFamily : process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                                fontWeight: "900", 
                                marginBottom: "10px",
                                minHeight : "0px",
                                opacity : 0.84,
                                textAlign : "center",
                                fontSize : "24px"
                            }}>{content?.display_name}</div>

                        {content?.linked_assets && 
                            <video 
                                style={{width: "100%", backgroundColor: "black"}} 
                                poster={getCdnPath(process.env.REACT_APP_CONTENT_VIDEO_POSTER)}
                                controls playsInline 
                                onEnded={() => {
                                    postEvent(device.deviceDetails, {
                                        category : "end-user-action",
                                        subcategory : "video-player",
                                        action : "video-ended",
                                        label : content.name,
                                        content_id : content?.pivot?.content_id,
                                        client_id : content?.client_id,
                                        campaign_id : content?.pivot?.campaign_id,
                                        trigger_id : content?.pivot?.trigger_id                                            
                                    },user);
                                    exitFullscreenMode();
                                }} 
                                onLoadedData ={() => updateContentStatus(content, 1, device.deviceDetails, user)}
                                onPause={() => console.log('Video paused')}
                                onPlay={() => {
                                    if(!videoPlayEventTracked) {
                                        postEvent(device.deviceDetails, {
                                            category : "end-user-action",
                                            subcategory : "video-player",
                                            action : "video-play",
                                            label : content?.name,
                                            content_id : content?.pivot?.content_id,
                                            client_id : content?.client_id,
                                            campaign_id : content?.pivot?.campaign_id,
                                            trigger_id : content?.pivot?.trigger_id
                                        },user)
                                    }

                                    setVideoPlayEventTracked(true);
                                }}>
                                    <source src={content?.linked_assets[0]?.path + "#t=0.001"} format={"video/" + content?.linked_assets[0]?.format}/>
                            </video> 
                        }

                        <div className={classes.Description} style={{
                                color: "black", 
                                fontFamily : process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY,
                                fontWeight : "500",
                                marginTop: "10px",
                                textAlign : "center",
                                fontSize : process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                                lineHeight: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_LINE_HEIGHT,
                                // opacity : 0.5,
                                width : "270px",
                                marginLeft : "auto",
                                marginRight : "auto",
                                height: "auto",
                                paddingBottom: "20px"
                                }}>
                            <div dangerouslySetInnerHTML={createMarkup(content?.description)}></div>
                            {/* <div><Button 
                                    style={{
                                        fontFamily: "Raleway",
                                        fontSize: "18px",
                                        fontWeight: "800",
                                        letterSpacing: 0.5,
                                        lineHeight: "21px",
                                        textTransform: "uppercase",
                                        color: "#2D75FF",
                                        marginTop: "20px",
                                        height: "50px",
                                        width: "100%",
                                        borderRadius: "10px",
                                        border: "#2D75FF 2px solid",
                                        backgroundColor : "#fff"
                                    }}
                                    btnText={videoPlayStopButtonTxt} 
                                    onClick={() =>toggleVideoPlayStopButton(videoIsPlaying)}/>

                                    {/* <div style={{width: "100%", height: "250px", backgroundColor: "white"}}>
                                        <div dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_TEST_RICH_TEXT)}></div>
                                </div> 
                            </div> */}
                        </div>
                        {sharable && <Button style={{
                            borderRadius:"50px",
                            border: "solid 3px #12177B",
                            backgroundColor: "#FFF",
                            color: "#12177B"
                        }}
                        btnText="Share Video"
                        onClick={() => {
                            if(window.location.protocol === 'https:') {
                                const event = {
                                    category: "end-user-action",
                                    subcategory : "behind-the-scenes",
                                    action : "share-video",
                                    label : content?.name,
                                    content_id : content?.pivot?.content_id,
                                    client_id : content?.client_id,
                                    campaign_id : content?.pivot?.campaign_id,
                                    trigger_id : content?.pivot?.trigger_id
                                }
                                postEvent(props.device, event,user);
                                navigator.share({
                                    url : window.location.href,
                                    text : process.env.REACT_APP_CONTENT_VIDEO_SHARE_TEXT,
                                    title : process.env.REACT_APP_META_TITLE
                                })                                            
                            }
                        }}
                        />}
                    </div>
                </div>
            )}
        </div>

        {/* {!showAgeGate && showActionButtons && actionButtons} */}
        {props.footer && <Footer />}
    </div>
);
    
}

export default BehindTheScenes;